import {Injectable} from "@angular/core";

@Injectable()
export class OptionsBilling {

    status = [
        {id: 1, itemName: "Em Aberto"},
        {id: 2, itemName: "Liberado Nação Digital"},
        {id: 3, itemName: "Liberado Cliente"},
        {id: 4, itemName: "Pgto. Pendente"},
        {id: 5, itemName: "Pago"},
        {id: 6, itemName: "Cancelado"},
        {id: 7, itemName: "Perda contábil"},
        {id: 8, itemName: "Perda competência"}
    ];

    division = [
        {id: 1, itemName: "Nação Digital"},
    ];

    statusAllParcels = [
        {id: 1, itemName: "Todas Em Aberto"},
        {id: 5, itemName: "Todas Pagas"}
    ];



}



// WEBPACK FOOTER //
// ./src/app/shared/enums/billing-letter/OptionsBilling.ts